import { render } from "./chat-form-input.vue?vue&type=template&id=cb084058"
import script from "./chat-form-input.vue?vue&type=script&lang=js"
export * from "./chat-form-input.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__